import React from "react";

const RatingInput = ({ value, onChange, field, width, maxLength, hint }) => {
  return (
    <input
      maxLength={maxLength}
      placeholder={hint}
      value={value}
      onChange={(e) => {
        onChange(e.target.value.replace(/[^a-z]\s/gi, ""), field);
      }}
      style={{
        color: "white",
        textAlign: "center",
        backgroundColor: "#2f2f2f",
        width,
        fontSize: "20px",
      }}
    />
  );
};

export default RatingInput;
